const LocationDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
    <g clipPath="url(#clip0_2695_40369)">
      <path
        d="M9 4.5C9 7.773 5.19234 11.6183 5.03044 11.7803C4.88976 11.921 4.699 12 4.50009 12C4.30119 12 4.11043 11.921 3.96975 11.7803C3.80766 11.6182 0 7.773 0 4.5C0 3.30653 0.474106 2.16193 1.31802 1.31802C2.16193 0.474106 3.30653 0 4.5 0C5.69347 0 6.83807 0.474106 7.68198 1.31802C8.52589 2.16193 9 3.30653 9 4.5ZM4.5 6.75C4.94501 6.75 5.38002 6.61804 5.75003 6.37081C6.12004 6.12357 6.40843 5.77217 6.57873 5.36104C6.74903 4.9499 6.79358 4.4975 6.70677 4.06105C6.61995 3.62459 6.40566 3.22368 6.09099 2.90901C5.77632 2.59434 5.37541 2.38005 4.93895 2.29323C4.5025 2.20642 4.0501 2.25097 3.63896 2.42127C3.22783 2.59157 2.87643 2.87996 2.62919 3.24997C2.38196 3.61998 2.25 4.05499 2.25 4.5C2.24999 4.79548 2.30818 5.08806 2.42125 5.36105C2.53431 5.63404 2.70005 5.88208 2.90898 6.09102C3.11792 6.29995 3.36596 6.46569 3.63895 6.57875C3.91194 6.69182 4.20452 6.75001 4.5 6.75Z"
        fill="#374151"
      />
    </g>
    <defs>
      <clipPath id="clip0_2695_40369">
        <rect width="9" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LocationDark;
